import { keyframes, styled } from '@mui/system'
import { TTheme } from '@/core/theme'

const ping = keyframes`
    0% {
        transform: scale(1);
        opacity: 0.7;
    }
    100% {
        transform: scale(2.6);
        opacity: 0;
    }
`

export const LoaderWithTextContainer = styled('div')<{
    theme?: TTheme
    direction?: 'rtl' | 'ltr'
}>`
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 4px 12px 4px 10px;
    border-radius: 999px;
    // background-color: ${({ theme }) => theme.colors.semantic.tableHeader};
    color: ${({ theme }) => theme.colors.greys[600]};
    flex-direction: ${({ direction }) =>
        direction === 'rtl' ? 'row' : 'row-reverse'};
`

export const PulsingDot = styled('span')<{ theme?: TTheme }>`
    display: inline-block;
    position: relative;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.primary[200]};
    flex-shrink: 0;
    z-index: 1;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.colors.semantic.liveAnimation};
        animation: ${ping} 1.8s ease-in-out infinite;
        z-index: -1;
    }

    @media (prefers-reduced-motion: reduce) {
        &::before {
            animation: none;
        }
    }
`
